// Image Imports
import BrochureMockUp from "assets/images/product-images/brochureMockUp.png";
import StationaryMockUp from "assets/images/product-images/stationaryMockUp.png";
import PosterMockUp from "assets/images/product-images/posterMockUp.png";

export default [
  {
    id: "100",
    image: BrochureMockUp,
    title: "Study Brochure",
    dimensions: "8.5“ x 14“",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    quantity: "Quantity: ",
    quantityOptions: [10, 20, 30, 40],
    action: { type: "internal", route: "/", color: "info", label: "Add To Cart" },
  },
  {
    id: "102",
    image: StationaryMockUp,
    title: "Stationary",
    dimensions: "8.5“ x 14“",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    quantity: "Quantity: ",
    quantityOptions: [10, 20, 30, 40],
    action: { type: "internal", route: "/", color: "info", label: "Add To Cart" },
  },
  {
    id: "103",
    image: PosterMockUp,
    title: "Study Poster",
    dimensions: "8.5“ x 14“",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    quantity: "Quantity: ",
    quantityOptions: [10, 20, 30, 40],
    action: { type: "internal", route: "/", color: "info", label: "Add To Cart" },
  },
];
